import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ThemeProvider } from "./components/ToggleTheme";
import { ResponsiveProvider } from "./utils/responsiveContext";
import { SessionProvider } from "./utils/useCurrentSession";
import { TitleProvider } from "./utils/useTitle";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <ResponsiveProvider>
    <SessionProvider>
      <ThemeProvider>
        <TitleProvider>
          <App />
        </TitleProvider>
      </ThemeProvider>
    </SessionProvider>
  </ResponsiveProvider>
  // </React.StrictMode>
);
